module.exports = __webpack_public_path__ + "img/lock-mail.55aaf5f7.png";